import script from "./DistiBotsTiles.vue?vue&type=script&setup=true&lang=js"
export * from "./DistiBotsTiles.vue?vue&type=script&setup=true&lang=js"

import "./DistiBotsTiles.vue?vue&type=style&index=0&id=0455b4e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0455b4e2"]])

export default __exports__